import { createFeature, createReducer, on } from '@ngrx/store';
import { PowerBIActions } from '../../actions/power-bi/power-bi.actions';
import { PowerBIEmbed, Report } from "@models/powerBIEmbed.model";
import { IReportEmbedConfiguration, models } from 'powerbi-client';
export const powerBIFeatureKey = 'powerBI';

export interface State {
  reports: Report[];
  embedToken: string | null;
  isLoading: boolean;
  isLoaded: boolean;
}

export const initialState: State = {
  reports: [],
  embedToken: null,
  isLoading: false,
  isLoaded: false,
};

export const reducer = createReducer(
  initialState,
  on(PowerBIActions.loadPowerBIs, state => ({ ...state, isLoading: true })),
  on(PowerBIActions.getEmbedDashboardSuccess, (state, action) => {
    let newReports: Report[]  = [];

    if (action.data.reports.length > 0) {

      newReports = action.data.reports.map((report: Report) => {
        let embedConfiguration: IReportEmbedConfiguration = {
            id: report.reportId,
            type: 'report',
            embedUrl: report.embedUrl,
            accessToken: action.data.embedToken.token,
            tokenType: models.TokenType.Embed,
            settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: true
            }
        };

        return {
          ... report,
          embedConfiguration: embedConfiguration
        }
        });
    }
      return {
        ...state,
        reports: newReports,
        embedToken: action.data.embedToken.token,
        isLoading: false,
        isLoaded: true,
      };
  }),
  on(PowerBIActions.getEmbedDashboardFailure, state => ({ ...state, isLoading: false, isLoaded: true }))
);

export const powerBIFeature = createFeature({
  name: powerBIFeatureKey,
  reducer,
});

